// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__N6fO2","leftPart":"navbar_leftPart__4ZE8x"};